import React from 'react';
import { Avatar, Box, Flex, Icon, Text, Link, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { MdCall, MdMail, MdCalendarMonth } from "react-icons/md";

const Banner = (props) => {
  const { 
    banner, 
    avatar, 
    name, 
    job, 
    email = "contact@example.com",
    phone = "+1234567890",
    calendlyUrl = "https://calendly.com/your-username"
  } = props;

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue("white !important", "#111C44 !important");
  const iconHoverBg = useColorModeValue("blue.50", "blue.900");

  const handleEmail = () => {
    window.location.href = `mailto:${email}`;
  };

  const handleCall = () => {
    window.location.href = `tel:${phone}`;
  };

  const handleCalendly = () => {
    window.open(calendlyUrl, '_blank');
  };

  const ActionButton = ({ icon, label, onClick }) => (
    <Flex 
      mx="auto" 
      me="60px" 
      align="center" 
      direction="column"
      cursor="pointer"
      onClick={onClick}
      role="button"
      _hover={{ transform: 'translateY(-2px)' }}
      transition="transform 0.2s"
    >
      <Box
        p="2"
        borderRadius="lg"
        _hover={{ bg: iconHoverBg }}
        transition="background 0.2s"
      >
        <Icon 
          as={icon} 
          color="blue.500" 
          h="36px" 
          w="36px"
        />
      </Box>
      <Text 
        color={textColorSecondary} 
        fontSize="sm" 
        fontWeight="700"
        mt="2"
      >
        {label}
      </Text>
    </Flex>
  );

  return (
    <Card mb={{ base: "0px", lg: "20px" }} align="center">
      <Box
        bg={`url(${banner})`}
        bgSize="cover"
        borderRadius="16px"
        h="131px"
        w="100%"
      />
      <Avatar
        mx="auto"
        src={avatar}
        h="127px"
        w="127px"
        mt="-93px"
        border="4px solid"
        borderColor={borderColor}
        bg="white"
      />
      <Text color={textColorPrimary} fontWeight="bold" fontSize="xl" mt="10px">
        {name}
      </Text>
      <Text color={textColorSecondary} fontSize="sm">
        {job}
      </Text>
      
      <Flex w="max-content" mx="auto" mt="26px">
        <ActionButton
          icon={MdMail}
          label="E-mail"
          onClick={handleEmail}
        />
        <ActionButton
          icon={MdCall}
          label="Appel"
          onClick={handleCall}
        />
        <Box mr="-60px">
          <ActionButton
            icon={MdCalendarMonth}
            label="Calendly"
            onClick={handleCalendly}
          />
        </Box>
      </Flex>
    </Card>
  );
};

export default Banner;